import VueRecaptcha from 'vue-recaptcha';

export default ({Vue}) => {
  Vue.use(VueRecaptcha);
}
